// extracted by mini-css-extract-plugin
module.exports = {"_statusIcons":"Lieferungsuebersicht__statusIcons__1Fra2","_statusIcon":"Lieferungsuebersicht__statusIcon__2FbYR"};